import { useState } from "react";
import CmModal from "../Controls/CmModal";
import CustomButton from "../Controls/CustomButton";

/**
 * Person notice viewer. Close does not resolve; Mark resolved is explicit.
 */
export default function NoticeDetailsModal({ notice, onClose, onResolved }) {
  const [busy, setBusy] = useState(false);
  const title = notice?.NoticeTypeDescription || notice?.noticeTypeDescription || "Notice";

  async function markResolved() {
    if (!notice || busy) return;
    setBusy(true);
    try {
      await onResolved?.(notice);
    } finally {
      setBusy(false);
    }
  }

  return (
    <CmModal
      open
      onClose={onClose}
      title={title}
      size="form"
      testId="notice-details-modal"
      footer={
        <>
          <CustomButton type="button" variant="contained" color="secondary" onClick={onClose} disabled={busy}>
            Close
          </CustomButton>
          {onResolved ? (
            <CustomButton
              type="button"
              variant="contained"
              color="primary"
              onClick={markResolved}
              disabled={busy}
              data-testid="notice-mark-resolved"
            >
              Mark resolved
            </CustomButton>
          ) : null}
        </>
      }
    >
      {!notice ? (
        <p>Notice not found.</p>
      ) : (
        <div className="cm-modal-body-pad" data-testid="notice-details-body">
          <p>
            <strong>Time:</strong> {notice.NoticeTime || notice.noticeTime || "—"}
          </p>
          <p>
            <strong>Message:</strong> {notice.Message || notice.message || "—"}
          </p>
        </div>
      )}
    </CmModal>
  );
}
